import * as React from 'react'
import { Label, Value } from './styled'
import { ReactElement } from 'react'
import { draftLeadCapturedInfoItemNames } from '../../constants'

type Props = {
  label: string
  value: string | ReactElement
}

export function NameValueListItem(props: Props) {
  const { label, value } = props
  if (
    label === draftLeadCapturedInfoItemNames.EmailAddress &&
    String(value)?.includes(';')
  ) {
    return (
      <div>
        <Label>{label}</Label>
        {Object(value)
          ?.split(';')
          .map((email: string) => {
            return <Value key={email}>{email}</Value>
          })}
      </div>
    )
  }
  return (
    <div>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </div>
  )
}
